module.exports = {
  aws_project_region: process.env.VUE_APP_AWS_REGION,
  aws_cognito_region: process.env.VUE_APP_AWS_REGION,
  aws_user_pools_id: process.env.VUE_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.VUE_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.VUE_APP_AWS_OAUTH_DOMAIN,
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: `${process.env.VUE_APP_BASE_URL}`,
    redirectSignOut: `${process.env.VUE_APP_BASE_URL}`,
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  // Auth: {
  //   cookieStorage: {
  //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
  //     domain: process.env.VUE_APP_COOKIE_DOMAIN,
  //     // OPTIONAL - Cookie path
  //     path: '/',
  //     // OPTIONAL - Cookie expiration in days
  //     expires: 365,
  //     // OPTIONAL - Cookie secure flag
  //     // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
  //     secure: process.env.VUE_APP_SECURE_COOKIE === 'true',
  //   },
  // },
  authenticationFlowType: 'USER_PASSWORD_AUTH',
};
